import React, { useState } from 'react'
import * as XLSX from 'xlsx';
import '../search-customer/search-customer.scss'
import SinglePage from '../../components/common/page/SinglePage'
import NormalInput from '../../components/common/inputs/NormalInput'
import SelectInput from '../../components/common/inputs/SelectInput'
import CheckboxInput from '../../components/common/inputs/CheckboxInput'
import Spinner from '../../components/common/spinners/SpinWithMessage'
import InfoBox from '../../components/common/info-box/InfoBox'
import TableFilter from '../../components/common/table-filter/TableFilter';
import Modal from '../../components/common/modal/Modal';
import { BiLoaderAlt } from 'react-icons/bi'
import { customerAxios } from '../../config/axios'
import { toast } from 'react-hot-toast'
import { FcSearch } from "react-icons/fc";
import { FcDeleteDatabase } from "react-icons/fc";
import { FaPlus } from 'react-icons/fa'
import { FiDownload } from "react-icons/fi";
import { productTypes } from '../../assets/javascript/const-data';
import AboutServiceWork from '../../components/user/service-work/AboutServiceWork';
import CUServiceWork from '../../components/user/service-work/CUServiceWork';



const ServiceWorkList = () => {
    const [form, setForm] = useState({
        search: '',
        applicable_for: '',
        allow_inactive: false
    })
    const [modal, setModal] = useState({ status: false })
    const [loading, setLoading] = useState('')
    const [data, setData] = useState([])
    const [ifSearch, setIfSearch] = useState(false)
  


    const handleChange = (e) => {

        if (e.target.name === 'allow_inactive') {
            setForm({
                ...form,
                allow_inactive: !form?.allow_inactive
            })

            return;
        }

        setForm({
            ...form,
            [e.target.name]: e.target.value
        })
    }

    const handleApply = (e) => {
        e.preventDefault();

        if (form.search && form.search.length < 3) {
            toast.error('Enter at least 3 characters')
            return;
        }

        if (!form?.search && !form?.applicable_for) {
            toast.error('Select any filter field')
            return;
        }

        setLoading('filter')
        customerAxios.get(`/production-v0/service-works`, {
            params: {
                search: form.search || '',
                applicable_for: form.applicable_for || '',
                include_inactive: form.allow_inactive === true ? 'true' : '',
                page: 1,
                limit: 1000,
                fields: 'uuid,work_id,work_name,selling_rate,purchase_cost,is_active,pricing_source,call_rate'
            }
        })
            .then((response) => {
                setIfSearch(true)
                setData(response.data?.data || [])
                setLoading('')
            }).catch((error) => {
                toast.error(error.message)
                setLoading('')
            })
    }

    const openCreateModel = () => {
        setModal({
            status: true, title: "Create new service work", width: '600px',
            content: <CUServiceWork setModal={setModal} setData={setData} isEdit={false} />
        })
    }

    // Download Handle
    const downloadFile = (workbook, filename) => {
        const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });

        const data = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        filename = filename + '.xlsx';

        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            // For IE browser
            window.navigator.msSaveOrOpenBlob(data, filename);
        } else {
            // For other browsers
            const url = window.URL.createObjectURL(data);
            const link = document.createElement('a');
            link.href = url;
            link.download = filename;
            link.click();
            window.URL.revokeObjectURL(url);
        }
    }

    const exportToExcel = (spare) => {

        const workbook = XLSX.utils.book_new();
        // DAR Setup
        const sheetName1 = 'Sheet 1';
        let workSheetData1 = []
        spare.map((data, index) => {
            const obj = {
                'WORK ID': data?.work_id,
                'WORK NAME': data?.work_name,
                'PRICING SOURCE': data?.pricing_source,
                'SELLING RATE (SR)': data?.selling_rate,
                'PURCHASE COST (PC)': data?.purchase_cost,
                'CALL RATE': data?.call_rate || 0,
                'STATUS': data?.is_active ? 'ACTIVE' : "INACTIVE",
            }
            workSheetData1.push(obj)
            return obj;
        })

        const worksheet1 = XLSX.utils.json_to_sheet(workSheetData1);
        XLSX.utils.book_append_sheet(workbook, worksheet1, sheetName1);

        return workbook;
    };

    const handleDownload = () => {
        if (data?.[0]) {
            const workbook = exportToExcel(data || [])
            downloadFile(workbook, `Service work List By Filter`)
        } else {
            toast.error('Data not available')
        }
    }

    return (
        <div className="search-customer-div">
            <Modal modal={modal} setModal={setModal} />
            <SinglePage titleArray={['Search Service Works']}>
                <div className="search-border-div">
                    <div className="filter-border-div">
                        <button className='add-button' type='button' onClick={() => openCreateModel()}> <FaPlus /> Create New Work</button>
                        <form action="" onSubmit={handleApply}>
                            <div className="search-section">
                                <h5>Search</h5>
                                <InfoBox description={'Your can search Work Id and Name'} />
                                <NormalInput label='Enter at least 3 characters' name='search' value={form.search} onChangeFun={handleChange} isRequired={false} />
                                <SelectInput label={'Applicable For'} name={'applicable_for'} isRequired={false} onChangeFun={handleChange}
                                    firstOption={{ option: 'Choose', value: '' }} values={productTypes?.map((a) => ({ option: a, value: a }))} />
                                <CheckboxInput label={'Include inactive'} name={'allow_inactive'} value={'true'} isRequired={false} onChangeFun={handleChange} />
                            </div>

                            {(form?.search || form?.applicable_for) &&
                                <div className="button-div">
                                    <button type='submit'>{loading === 'filter' ? <span className='loading-icon'><BiLoaderAlt /></span> : "Filter"}</button>
                                </div>}
                        </form>
                    </div>

                    <div className="result-div">
                        <div className="header-div">
                            {ifSearch ? <h4>{data?.length || '0'} {data?.length > 1 ? 'Results' : 'Result'}</h4>
                                : <h4>Search Service Works</h4>
                            }
                            <div className="right-div">
                            </div>
                        </div>
                        <div className="items-div">
                            {data?.[0] ?
                                <TableFilter>
                                    <table className='table'>
                                        <thead>
                                            <tr>
                                                <th>Work Id</th>
                                                <th>Work Name</th>
                                                <th>Price Source</th>
                                                <th>Selling Rate</th>
                                                <th>Purchase Cost</th>
                                                <th>Call Rate</th>
                                                <th>Status</th>
                                                <th>Control</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {data?.map((work) => {
                                                return <tr key={work.work_id}>
                                                    <td>{work?.work_id}</td>
                                                    <td>{work?.work_name}</td>
                                                    <td>{work?.pricing_source}</td>
                                                    <td>₹ {work?.selling_rate || 0}</td>
                                                    <td>₹ {work?.purchase_cost || 0}</td>
                                                    <td>{work?.call_rate}</td>
                                                    <td style={{ color: work?.is_active ? 'green' : 'red', fontWeight: "600" }} >
                                                        {work?.is_active ? 'Active' : 'In Active'}
                                                    </td>
                                                    <td>
                                                        <div className="button-div">
                                                            <button onClick={() => setModal({
                                                                status: true, title: 'About Service Work', width: '600px',
                                                                content: <AboutServiceWork workId={work?.work_id} />
                                                            })}>View</button>
                                                        </div>
                                                    </td>
                                                </tr>
                                            })}
                                        </tbody>
                                    </table>
                                </TableFilter>
                                : <>
                                    <Spinner height={'300px'} spin={false} message={ifSearch ? 'No matched data' : 'Search service works'}
                                        icon={ifSearch ? <FcDeleteDatabase /> : <FcSearch />} />
                                </>}
                        </div>
                        {data?.[0] && <div className="download-button" title='Download XL file' onClick={handleDownload}>
                            <FiDownload />
                        </div>}
                    </div>
                </div>
            </SinglePage>
        </div>
    )
}

export default ServiceWorkList